// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "LazyIdentificationForm" + "." + "e3400109ac4336111ed7" + ".css";
};